export default __webpack_public_path__ + "static/media/AbdoulayeBarryM.b1479100.mp4";